(function() {
   
    function controlsCoreVideo() {
      const buttonsPlay = document.querySelectorAll('.js-play-video');
      const buttonsSound = document.querySelectorAll('.js-sound-video');
  
      buttonsPlay.forEach(button => {
        button.onclick = () => {
          if (button.previousElementSibling.classList.contains('video-file-inline') || button.previousElementSibling.previousElementSibling.classList.contains('video-file-inline')) {
            const o_video = button.previousElementSibling.querySelector('video');
            if (o_video) {
              if (o_video.paused) {
                pauseAllMedia();
                setTimeout(() => {
                  o_video.play();
                }, 10);
                button.classList.add('active');
              }
              else {
                setTimeout(() => {
                  o_video.pause();
                }, 10);
                button.classList.remove('active');
              }
              // button.classList.toggle('active');
            }
  
            const videoUrl = button.previousElementSibling.querySelector('iframe');
            if (videoUrl) {
              if (videoUrl.classList.contains('video-pause')) {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "playVideo" + '","args":""}',
                    "*",
                  );
                  if (videoUrl.classList.contains('video-muted')) {
                    videoUrl.contentWindow.postMessage(
                      '{"event":"command","func":"' + "mute" + '","args":""}',
                      "*",
                    );
                  }
                  else {
                    videoUrl.contentWindow.postMessage(
                      '{"event":"command","func":"' + "unMute" + '","args":""}',
                      "*",
                    );
                  }
                  videoUrl.classList.add('video-play');
                  videoUrl.classList.remove('video-pause');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"play"}', "*");
                  if (videoUrl.classList.contains('video-muted')) {
                    videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                  }
                  else {
                    videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                  }
                  videoUrl.classList.add('video-play');
                  videoUrl.classList.remove('video-pause');
                }
              }
              else {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                    "*",
                  );
                  videoUrl.classList.add('video-pause');
                  videoUrl.classList.remove('video-play');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"pause"}', "*");
                  videoUrl.classList.add('video-pause');
                  videoUrl.classList.remove('video-play');
                }
              }
              button.classList.toggle('active');
            }
          }
        }
      });
  
      buttonsSound.forEach(button => {
        button.onclick = () => {
          if (button.previousElementSibling.classList.contains('video-file-inline') || button.previousElementSibling.previousElementSibling.classList.contains('video-file-inline')) {
            const video = button.previousElementSibling.querySelector('video') || button.previousElementSibling.previousElementSibling.querySelector('video');
            if (video) {
              if (video.muted) {
                muteAllMedia();
                // pauseAllMedia();
                // video.play();
                setTimeout(() => {
                  video.muted = false;
                }, 10);
                button.classList.remove('active');
              }
              else {
                setTimeout(() => {
                  video.muted = true;
                }, 10);
                button.classList.add('active');
              }
              // button.classList.toggle('active');
            }
  
            const videoUrl = button.previousElementSibling.querySelector('iframe') || button.previousElementSibling.previousElementSibling.querySelector('iframe');
            if (videoUrl) {
              if (videoUrl.classList.contains('video-muted')) {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "unMute" + '","args":""}',
                    "*",
                  );
                  videoUrl.classList.remove('video-muted');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
                  videoUrl.classList.remove('video-muted');
                }
              }
              else {
                if (videoUrl.classList.contains('js-youtube')) {
                  videoUrl.contentWindow.postMessage(
                    '{"event":"command","func":"' + "mute" + '","args":""}',
                    "*",
                  );
                  videoUrl.classList.add('video-muted');
                }
                else if (videoUrl.classList.contains('js-vimeo')) {
                  videoUrl.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
                  videoUrl.classList.add('video-muted');
                }
              }
              button.classList.toggle('active');
            }
          }
        }
      })
  
    }
    controlsCoreVideo();
  
  })()